import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function BackToOverview() {
  return (
    <Link to="/admin" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "var(--secondary)", textDecoration: "none", marginBottom: 14 }} data-testid="back-to-overview">
      <ArrowLeft size={12} weight="bold" /> Back to overview
    </Link>
  );
}
